import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocationService } from '../../location.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BranchMaster } from 'app/masters/models/branch-master.model';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-search-ipd-patient-location',
  templateUrl: './search-ipd-patient-location.component.html',
  styleUrls: ['./search-ipd-patient-location.component.scss']
})
export class SearchIpdPatientLocationComponent implements OnInit {
  dataSource = new MatTableDataSource<BranchMaster>();
  selection = new SelectionModel<any>(true, []);
  destroyipdsearchLocation$: Subject<boolean> = new Subject<boolean>();
   displayedColumns: string[] = ['categoryName', 'categoryCode', 'iconName', 'isActive'];
  constructor(public dialog: MatDialog,
    public locationService: LocationService,
    private dashboardService: DashboardService,
    public dialogRef: MatDialogRef<SearchIpdPatientLocationComponent>
  ) { }

  ngOnInit(): void {
    this.ipdLocationMaster()
  }


   ipdLocationMaster(){
      this.locationService.GetIPDLocationMaster(0).pipe(takeUntil(this.destroyipdsearchLocation$)).subscribe((res) => {
        this.dataSource.data = res;
        console.log( this.dataSource,'called res search')
         this.dataSource.filterPredicate = (data: any, filter: string) => {
        const searchTerm = filter.trim().toLowerCase();

  return (
    (data.categoryName && data.categoryName.toLowerCase().includes(searchTerm))
  );
};
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message,"OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    }
    applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    selectRow(row) {
      console.log(row,'called double click')
      this.selection.toggle(row);
      this.dialogRef.close(row);
    }

  closedialog() {
    this.dialog.closeAll();
  }

  ngOnDestroy() {
    this.destroyipdsearchLocation$.next(true);
    this.destroyipdsearchLocation$.unsubscribe();
  }
}
